import type { FieldMergeFunction } from '@apollo/client'

export const mergePreservePopulatedString: FieldMergeFunction<string | null | undefined> = (existing, incoming) => {
  if (existing != null && incoming == null) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[apollo-cache] preserved populated string over null incoming')
    }
    return existing
  }
  return incoming
}
